import Header from "../components/templates/Header"
import { useDispatch, useSelector } from 'react-redux'
import CustomAlert from "../components/alert/CustomAlert";
const DefaultTemplate = (props) => {
    const alert_config = useSelector(state => state.alert.alert_config);

    return (
        <>
            <Header />
            <CustomAlert success={alert_config.success} danger={alert_config.danger} showModel={alert_config.show_alert} title={alert_config.title} message={alert_config.message} />
            {
                props.children
            }

            <section class="footer-area padding-top-100px padding-bottom-30px">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-3 responsive-column">
                            <div class="footer-item">
                                <div class="footer-logo padding-bottom-30px">
                                    <a href="index.html" class="foot__logo">
                                        <img src="https://apnaatravel.com/assets/website//images/logo.png" width="200" alt="logo" />
                                    </a>
                                </div>

                                <ul class="list-items pt-3">
                                    <li> 272, 1A, A-Block, Mahipalpur Extension, Mahipalpur, New Delhi, Delhi 110037</li>
                                    <li>+91-9871552247</li>
                                    <li><a href="mailto:info@apnaatravel.com">info@apnaatravel.com</a></li>

                                </ul>
                                <br />
                                <span id="siteseal"><script async="" type="text/javascript" src="https://seal.godaddy.com/getSeal?sealID=LfMY9P2ctI3EBvslHfZnXEQvbZEWNbNjxJte9KxBvkbpXMRw4RiCfvWy39fz"></script><img  src="https://seal.godaddy.com/images/3/en/siteseal_gd_3_h_l_m.gif" alt="SSL site seal - click to verify" /></span>
                            </div>
                        </div>
                        <div class="col-lg-3 responsive-column">
                            <div class="footer-item">
                                <h4 class="title curve-shape pb-3 margin-bottom-20px" data-text="curvs">Company</h4>
                                <ul class="list-items list--items">
                                    <li><a href="https://apnaatravel.com/about-us">About us</a></li>
                                    <li><a href="https://apnaatravel.com/contact-us">Contact Us</a></li>
                                    <li><a href="https://apnaatravel.com/faq">Faq's</a></li>
                                    <li><a href="#">Careers</a></li>
                                    <li><a href="https://apnaatravel.com/List-your-Property">List your Property</a></li>
                                    <li><a href="https://apnaatravel.com/List-your-Cab">List your Cab</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3 responsive-column">
                            <div class="footer-item">
                                <h4 class="title curve-shape pb-3 margin-bottom-20px" data-text="curvs">Other Links</h4>
                                <ul class="list-items list--items">
                                    <li><a href="https://apnaatravel.com/Terms-Condition">Terms &amp; Condition</a></li>
                                    <li><a href="https://apnaatravel.com/Privacy-Policy">Privacy Policy</a></li>
                                    <li><a href="https://apnaatravel.com/contact-us">Help Center</a></li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3 responsive-column">
                            <div class="footer-item">
                                <h4 class="title curve-shape pb-3 margin-bottom-20px" data-text="curvs">Follow Us</h4>

                                <div class="footer-social-box text-right-1">
                                    <ul class="social-profile">
                                        <li><a href="https://www.facebook.com/onstrip"><i class="lab la-facebook-f"></i></a></li>
                                        <li><a href="https://twitter.com/?lang=en"><i class="lab la-twitter"></i></a></li>
                                        <li><a href="https://www.instagram.com/?hl=en"><i class="lab la-instagram"></i></a></li>
                                        <li><a href="https://www.linkedin.com/"><i class="lab la-linkedin-in"></i></a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="section-block mt-4"></div>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-7">
                            <div class="copy-right padding-top-30px">
                                <p class="copy__desc">
                                    © Copyright Apnaatravel 2021.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="copy-right-content d-flex align-items-center justify-content-end padding-top-30px">
                                <h3 class="title font-size-15 pr-2">We Accept</h3>
                                <img src="https://apnaatravel.com/assets/website//images/payment-img.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DefaultTemplate